import { IBaseInfo } from "../store"

export type IPaymentInfo = IBaseInfo;

export enum PAYMENT_INFO_ACTION_TYPE {    
    INFO_SELECT = 'payment-info/info-select',
    INFO_RESET = 'payment-info/info-reset'    

};

export type IPaymentInfoState = {
    selected: IPaymentInfo | undefined
};

function getPaymentInfoInitialState(): IPaymentInfoState {
    return {
        selected: undefined        
    };
}

export function paymentInfoReducer(state = getPaymentInfoInitialState(), action: {type: PAYMENT_INFO_ACTION_TYPE, payload: any}) {
    switch (action.type) {
        case PAYMENT_INFO_ACTION_TYPE.INFO_SELECT:
            return {...state, selected: action.payload};
        case PAYMENT_INFO_ACTION_TYPE.INFO_RESET:
                return {...state, selected: undefined};        
        default:
            return state;
    }
}